exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".InfluencerAnalyticsHome_content__2v6jA {\n  background-color: #f4f8f9;\n  -webkit-flex-grow: 1;\n          flex-grow: 1;\n  width: 100%; }\n  .InfluencerAnalyticsHome_content__2v6jA .InfluencerAnalyticsHome_title__3AN9a {\n    color: #044591;\n    margin: 0 10px 0 0; }\n  .InfluencerAnalyticsHome_content__2v6jA .InfluencerAnalyticsHome_tabAnalytics__1Dg8g.MuiTab-root {\n    min-width: unset;\n    padding: 0px 5px; }\n", ""]);

// exports
exports.locals = {
	"content": "InfluencerAnalyticsHome_content__2v6jA",
	"title": "InfluencerAnalyticsHome_title__3AN9a",
	"tabAnalytics": "InfluencerAnalyticsHome_tabAnalytics__1Dg8g"
};